module.exports = __webpack_public_path__ + "img/mc_cafe.5fe11849.webp";